import { useApiClient } from 'bff/ApiClientProvider';
import { queryOptions } from '@tanstack/react-query';
import { ReportingGetPortfolioSummaryRequest } from 'bff/client';

export const portfolioSummaryKeys = {
  base: () => ['portfolioSummary'] as const,
  fetch: (request: ReportingGetPortfolioSummaryRequest) => [...portfolioSummaryKeys.base(), request]
};

export const getPortfolioSummary = (request: ReportingGetPortfolioSummaryRequest) => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: portfolioSummaryKeys.fetch(request),
    queryFn: async () => reportingApi.reportingGetPortfolioSummary(request),
    select: (response) => response.data
  });
};
